export const TABLE_HEADER_HEIGHT_ENUM = {
  default: {
    label: 'default',
    value: 'default',
    height: '40px',
    headerCellStyle: () => { return { height: '40px' } },
  },
  small: {
    label: 'default',
    value: 'small',
    height: '24px',
    headerCellStyle: () => { return { height: '24px' } },
  },
}

export const composeFn = (fns = [], mergeRetFn = (item, acc) => item + acc, initValue = '') => {
  return (...args) => {
    return fns.filter(item => typeof item === 'function').map(fn => fn(...args)).reduce(mergeRetFn, initValue)
  }
}

/**
 * 依次执行函数, 每个函数都是返回对象, 最后合并对象
 * @param {*} fns
 * @returns 返回一个包装函数
 */
export const composeFnObj = (fns = []) => {
  return composeFn(fns, (a, b) => ({ ...a, ...b }), {})
}

/**
 * 依次执行函数, 每个函数都是返回数组, 最后合并数组
 * @param {*} fns
 * @returns 返回一个包装函数
 */
export const composeFnArr = (fns = []) => {
  return composeFn(fns, (a, b) => ([...a, ...b]), [])
}

/**
 * 依次执行函数, 每个函数都是字符串, 最后合并字符串, 且保留空格
 * @param {*} fns
 * @returns 返回一个包装函数
 */
export const composeFnStrSpace = (fns = []) => {
  return composeFn(fns, (a, b) => (`${a} ${b}`), '')
}
